// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2XlAm","inputDescription":"styles_inputDescription__1QK6p"};